import { Item } from "@/services/backend/htz/inspection/types/structural-assessment-catalog";
import { Result } from "@/services/backend/htz/inspection/components/inspection-result";
import { Assessment } from "./assessment";
import { UUID } from "@bitory-gmbh/nidavellir";

export type StructuralAssessment = Assessment & {
  requirement: string;
  deficiency: string;
  recommendation: string;
  comment: string;
  conductedAt: string;
  result: Result;
};

export function newStructural(
  id: string,
  ahuId: string,
  componentId: string,
): StructuralAssessment {
  return {
    id,
    ahuId,
    componentId,
    requirement: "",
    deficiency: "",
    recommendation: "",
    comment: "",
    conductedAt: new Date().toISOString(),
    result: Result.ZERO,
  };
}

export function fromCatalogItem(
  id: string,
  ahuId: UUID,
  componentId: string,
  item: Item,
): StructuralAssessment {
  return {
    ...item,
    id,
    ahuId,
    componentId,
    comment: "",
    conductedAt: new Date().toISOString(),
  };
}
